import getStringTemplate from './getStringTemplate';

function getPixleeContentFromAlbum (albumConfig) {

	const URL = getStringTemplate(albumConfig);
	return fetch(URL, {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json; charset=utf-8'
		},
		method: 'GET',
		cache: 'no-cache'
	}).then((response) => response.json());

}

export default getPixleeContentFromAlbum;
